import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgMijnGegevens = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FFBFA5"
      d="M32 12H8a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V14a2 2 0 0 0-2-2"
    />
    <path
      fill="#FF7842"
      d="M12.5 23.5a4.5 4.5 0 1 0 0-9 4.5 4.5 0 0 0 0 9"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M8 28a4.49 4.49 0 0 1 4.5-4.5A4.49 4.49 0 0 1 17 28z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M10.36 19.75a2.14 2.14 0 1 0 4.28 0h1a3.14 3.14 0 1 1-6.28 0z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M32 16.5H20v-1h12zM32 19.5H20v-1h12zM32 22.5H20v-1h12z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M31.5 30.498V26h1v4.503a2.01 2.01 0 0 1-2.01 1.997H20v-1h10.49a1.01 1.01 0 0 0 1.01-1.002"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgMijnGegevens);

export default ForwardRef;
